export default __webpack_public_path__ + "static/media/exterior3.3163d62b.jpeg";